import gsap from "gsap";

const navbar = document.getElementById("navbar");
const menuToggles = Array.from(
	document.querySelectorAll("button.header__menu-toggle")
);
const mobileMenu = document.getElementById("mobile-menu");
const overlay = document.getElementById("overlay"); // Create an overlay element
const scrollIndicator = document.getElementById("scroll-indicator");
const quickExitButtons = document.querySelectorAll("button.js-quick-exit");

if (quickExitButtons) {
	Array.from(quickExitButtons).map((quickExitButton) => {
		quickExitButton.addEventListener("click", function () {
			window.open("https://www.google.com.au", "_blank");
			window.location.replace("https://www.google.com.au");
		});
	});
}

let ticking = false;

window.addEventListener("scroll", function () {
	if (!ticking) {
		requestAnimationFrame(() => {
			updateScrollEffects();
			ticking = false;
		});
		ticking = true;
	}
});

function updateScrollEffects() {
	if (window.scrollY > 100) {
		navbar.setAttribute("data-scrolled", "true");
	} else {
		navbar.setAttribute("data-scrolled", "false");
	}

	const docHeight = document.documentElement.scrollHeight - window.innerHeight;
	const scrollPercent = (window.scrollY / docHeight) * 100;

	gsap.to(scrollIndicator, { width: scrollPercent + "%" });
}

menuToggles.forEach((menuToggle) => {
	menuToggle?.addEventListener("click", () => {
		const isMenuExpanded = mobileMenu.getAttribute("aria-expanded") === "true";
		document.body.classList.toggle("no-scroll", !isMenuExpanded);

		if (isMenuExpanded) {
			gsap.to(mobileMenu, { x: "-100%", duration: 0.5 }); // Slide the menu out
			gsap.to(overlay, {
				opacity: 0,
				duration: 0.3,
				onComplete: () => (overlay.style.display = "none"),
			}); // Hide overlay
			mobileMenu.setAttribute("aria-expanded", "false");
		} else {
			gsap.to(mobileMenu, { x: "1rem", duration: 0.5 }); // Slide the menu in
			overlay.style.display = "block"; // Show the overlay
			gsap.to(overlay, { opacity: 1, duration: 0.3 }); // Fade in the overlay
			mobileMenu.setAttribute("aria-expanded", "true");
		}
	});
});

// Close the menu when clicking on the overlay
overlay.addEventListener("click", () => {
	if (mobileMenu.getAttribute("aria-expanded") === "true") {
		gsap.to(mobileMenu, { x: "-100%", duration: 0.5 }); // Slide the menu out
		gsap.to(overlay, {
			opacity: 0,
			duration: 0.3,
			onComplete: () => (overlay.style.display = "none"),
		});
		mobileMenu.setAttribute("aria-expanded", "false");
	}
});
